<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="mira">
<h2>Mira</h2>
<p><em>Our help is in the Name of the Lord</em>…Well where is my help? Here I am almost day in and day out. The same old problems or should I not be so cruel. It is not cruel when I am forced to be judge, jury, and official hand holder? I don’t know anymore. I feel I am being punished for some obscure sin that I can’t even remember? Was it last Christmas when I…I…See! I don’t even remember! Aagh!</p>
<p><em>Libera me</em>…Pray for what? I don’t even know where to begin. There are so many! Peace of mind? That’s ripe! When in doubt, punt. The old standby. Peace of mind? That will never happen to human beings except when they put the coins on our eyes. And then we’ll know. The living will still be in the dark. A letter from the other side? I sure would like to see the postage on that!</p>
<p><em>Pater</em>…Father I have sinned. Please forgive me! No, no! Self-pity? Well why not? There I go again! Being selfish again. Father, forgive whoever did wrong for causing this grief! I can’t talk like this! I am losing my sanity or what is left. Kind and merciful? Yeah right! I am so sorry!</p>
<p><em>Eloi, Eloi</em>…Have I been abandoned? I must have been. This would not have happened if it were someone else. It never happens to the beautiful people. Just us ugly folk.</p>
<p><em>Ad nauseum</em>…Am I repeating myself? Can I not think straight? Is my mind a circle? No more excuses? Are other folks tired of my voice or my tears? Why am I forced to suffer this burden alone? They are all cowards! I must be strong! I have no choice!</p>
<p><em>Pacem in terris</em>…I must get this strength from somewhere. Inside me? There is nothing left. From the neighbor? From the minister? All words and no substance. From a complete stranger? Perhaps. Hello my child. Yes, I know you. You do. I am your strength and courage. I am a mirror of all things. I am a mirror of you. Blemishes, warts, scars and all the imperfections that make up you, you, and you. I am the strength that lies in all of us. I am a rock. I am the spring eternal. I am your very soul. I am you.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?964553da